<template>
  <div class="message" :title="message.sender.full_name">
    <div class="msg-header">
      <img class="avatar" :src="message.sender.avatar">
      <p class="mb-0 ml-1">{{ message.sender.full_name }}</p>
      <!--      <p class="small mb-0 text-center">{{ hour }}</p>-->
      <div class="ml-auto" v-if="mine">
        <b-dropdown variant="transparent" toggle-class="more-button" dropright no-caret>
          <template slot="button-content">
            <i class="ti-more-alt"></i>
          </template>
          <b-dropdown-item @click="destroy">
            <i class="ti-trash text-blue"/>
            Supprimer
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="content py-1">
      <div v-if="message.textContent"
           class="text-content mb-1">
        <span style="white-space: pre-line">{{ message.textContent }}</span>
      </div>
      <div class="w-100 mb-1" v-if="message.audio">
        <audio-player class="audio-player mini" :src="message.audio"></audio-player>
      </div>
      <div class="w-100 mb-1" v-if="message.images.length">
        <question-images :images="message.images"/>
      </div>
      <div class="actions text-right">
        <button v-if="!response" class="btn btn-outline-primary reply-btn" @click="reply">
          <i class="ti-arrow-left"></i>
          Répondre
        </button>
      </div>
    </div>

    <div class="responses" v-if="responses && responses.length">
      <message response v-for="(message,i) in responses" :message="message" :key="i"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import QuestionImages from "@/components/Questions/QuestionImages";
import moment from 'moment'

export default {
  name: "Message",
  components: {QuestionImages},
  props: {message: {required: true}, responses: {}, response: {type: Boolean, default: false}},
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['user']),
    mine() {
      return this.message.sender_id === this.user.id
    },
    hour() {
      return this.message.time.format('HH:mm')
    }
  },
  methods: {
    reply() {
      this.$emit('reply')
    },
    destroy() {
      this.loading = true
      this.$store.dispatch('chat/deleteMessage', {id: this.message.id, discussion: this.message.discussion_id})
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style lang="scss">
.message {
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  background: white;
  margin-bottom: 20px;

  .msg-header {
    display: flex;
    align-items: center;

    p {
      @include no-break();
    }

    .more-button {
      background: transparent;
      border: none;
      padding: 0;

      i:before {
        display: block;
        transform: rotate(90deg);
      }
    }

    .dropdown-menu {
      padding: 0;
      font-size: 12px;
      min-width: auto;
    }
  }

  .reply-btn {
    border-radius: 20px;
    max-width: 150px;
    @include no-break();
    font-size: 12px;
  }


  .user-tag {
    color: $green;
    cursor: pointer;
    margin-right: 2px;

    &:hover {
      text-decoration: underline;
    }
  }

  .avatar {
    @include square(30px);
  }

  .content {
    flex-grow: 1;

    .text-content {
      display: inline-block;
      background: white;
      color: black;
      word-break: break-word;
      border-radius: 3px;
      padding: 5px;
    }
  }

  .responses {
    border-left: 1px solid #ccc;
    margin-left: 10px;

    .message {
      border: none;
    }
  }
}
</style>
